/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { createGroupUser, updateGroupUsers } from "./../../../services/api";
import { useSelector } from "react-redux";
import { TextField, Checkbox, Tabs, Tab, Dialog, DialogActions, DialogContent, DialogTitle, TableContainer, Table, TableBody, TableRow, TableCell } from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import { deepCopy } from "../../../services/libService";

const EditUserGroup = ({ initialData, onSaveResponse, onCreateResponse, editable = false, onClose }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({ name: "", description: "" });
  const permissions = useSelector((state) => state.data.permission);
  const menu = useSelector((state) => state.data.menu);
  const [tab, setTab] = useState(0);
  const [currentPermission, setCurrentPermission] = useState(""); //permision cua usergroup dang edit
  const [currentMenu, setCurrentMenu] = useState("");
  const [dgWidth, setDgWidth] = useState("sm");
  useEffect(() => {
    setCurrentPermission("");
    if (initialData === false) {
      setInputData({
        name: "",
        description: "",
      });
    } else if (initialData?.id) setInputData(initialData);
  }, [initialData]);
  useEffect(() => {
    if (!permissions || initialData === null) return;
    if (initialData === false) {
      setCurrentPermission(JSON.parse(JSON.stringify(permissions)));
      return;
    }
    // Object.keys(permissions).forEach(key => a[key] = initialData.permissions && JSON.parse(initialData.permissions)[key] || permissions[key])
    let a = permissions;
    let aa = JSON.parse(initialData.permissions); //perm cua du lieu user
    let d = {};
    Object.keys(permissions).forEach((key) => {
      // key: Org
      let b = a[key]; //{List: '', Update: ''}
      let bb = aa && aa[key]; //{List: 1}
      let c = {}; //c la object moi cua Org
      Object.keys(b).forEach((sub_key) => {
        //sub_key: List
        c[sub_key] = (bb && bb[sub_key]) || b[sub_key];
      });
      d[key] = c || a[key];
    });
    setCurrentPermission(d);
  }, [initialData, permissions]);

  // lấy menu mới từ BE rồi so sánh với menu hiện tại của group, nếu có key nào mới thì sẽ tự động thêm vào menu của group
  useEffect(() => {
    if (!menu) return;
    const newObject = {};
    const currentObject = {};
    initialData?.menu &&
      JSON.parse(initialData.menu || "")
        ?.filter((i) => i)
        .forEach?.((item) => {
          const subObject = {};
          item.submenu.forEach((subItem) => {
            subObject[subItem.code] = subItem;
          });
          currentObject[item.code] = { ...item, submenu: subObject };
        });
    menu.forEach((item) => {
      const subObject = {};
      item.submenu.forEach((subItem) => {
        subObject[subItem.code] = subItem;
      });
      newObject[item.code] = { ...item, submenu: subObject };
    });
    Object.keys(currentObject).forEach((key) => {
      if (newObject[key]) {
        newObject[key].value = currentObject[key].value || false;
        Object.keys(newObject[key].submenu).forEach((subKey) => {
          newObject[key].submenu[subKey] = { ...newObject[key].submenu[subKey], value: currentObject[key]?.submenu?.[subKey]?.value || false };
        });
      }
    });
    Object.keys(newObject).forEach((key) => {
      newObject[key].submenu = Object.values(newObject[key].submenu);
    });
    const newMenu = Object.values(newObject);
    setCurrentMenu(newMenu);
  }, [initialData, menu]);

  const handleName = (e) => {
    setInputData({ ...inputData, name: e.target.value });
  };

  const handleDescription = (e) => {
    setInputData({ ...inputData, description: e.target.value });
  };
  const handleClick = () => {
    if (inputData.id)
      return updateGroupUsers(inputData.id, {
        ...inputData,
        permissions: currentPermission,
        menu: currentMenu.map((item) => (!item ? item : { ...item, value: Boolean(item.submenu.some((sub_item) => sub_item.value)) })),
      });
    return createGroupUser({
      ...inputData,
      permissions: currentPermission,
      menu: currentMenu.map((item) => (!item ? item : { ...item, value: Boolean(item.submenu.some((sub_item) => sub_item.value)) })),
    });
  };
  const handleChangePermission = (key1, key2) => {
    let newPermission = { ...currentPermission };
    newPermission[key1][key2] = {
      ...newPermission[key1][key2],
      value: !newPermission[key1][key2].value,
    };
    setCurrentPermission(newPermission);
  };
  const handleChangeMenu = (y, x) => {
    const newMenu = Object.values(deepCopy(currentMenu));
    newMenu.filter((i) => i)[y].submenu[x].value = !newMenu.filter((i) => i)[y].submenu[x].value;
    setCurrentMenu(newMenu);
  };
  return (
    <Dialog open={initialData !== null} onClose={onClose} fullWidth maxWidth={dgWidth}>
      <DialogTitle align="center">{t(inputData.id ? "Chỉnh sửa thông tin nhóm người dùng" : "Tạo nhóm người dùng")}</DialogTitle>
      <DialogContent align="center">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          <Tabs value={tab}>
            <Tab
              onClick={() => {
                setTab(0);
                setDgWidth("sm");
              }}
              label={t("Thông tin")}
            />
            <Tab
              onClick={() => {
                setTab(1);
                setDgWidth("lg");
              }}
              label={t("Phân quyền")}
            />
            <Tab
              onClick={() => {
                setTab(2);
                setDgWidth("lg");
              }}
              label={t("Menu")}
            />
          </Tabs>
        </div>
        <div hidden={tab !== 0}>
          <TextField id="name-basic" label={t("Tên nhóm")} onChange={handleName} value={inputData.name} fullWidth style={{ marginTop: 10 }} InputLabelProps={{ shrink: true }} disabled={!editable} />
          <TextField
            id="description-basic"
            label={t("Mô tả")}
            onChange={handleDescription}
            value={inputData.description}
            fullWidth
            style={{ marginTop: 10 }}
            InputLabelProps={{ shrink: true }}
            disabled={!editable}
          />
        </div>
        <div hidden={tab !== 1}>
          {currentPermission && (
            <TableContainer>
              <Table>
                <TableBody>
                  {currentPermission &&
                    Object.keys(currentPermission).map((key1) => {
                      const numberOfKeys = Object.keys(currentPermission[key1]).length; //7
                      const numberOfRow = Math.ceil(numberOfKeys / 3);
                      return (
                        <React.Fragment key={key1}>
                          {[...Array(numberOfRow)].map((i, index) => (
                            <TableRow key={index}>
                              {index == 0 && (
                                <TableCell rowSpan={numberOfRow} align="left">
                                  <b>{t(key1.toString())}:</b>
                                </TableCell>
                              )}
                              {Object.keys(currentPermission[key1])
                                // .sort()
                                .slice(index * 3, (index + 1) * 3)
                                .map((key2, sub_index) => {
                                  const a = index * 3 + sub_index + 1;
                                  const colSpan = a == numberOfKeys ? 3 + 1 - sub_index : 1;
                                  return (
                                    <TableCell colSpan={colSpan} key={sub_index} style={{ textAlign: "left" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Checkbox disabled={!editable} checked={Boolean(currentPermission[key1][key2].value)} onClick={() => handleChangePermission(key1, key2)} />
                                        {t(key2.toString())}
                                      </div>
                                    </TableCell>
                                  );
                                })}
                            </TableRow>
                          ))}
                        </React.Fragment>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
        <div hidden={tab !== 2}>
          <TableContainer>
            <Table>
              <TableBody>
                {currentMenu
                  ?.filter?.((i) => i)
                  .map((item, idx, array) => {
                    const numberOfKeys = item.submenu?.length; //7
                    const numberOfRow = Math.ceil(numberOfKeys / 3);
                    return (
                      <React.Fragment key={idx}>
                        {[...Array(numberOfRow)].map(
                          (
                            i,
                            index // index la so dong
                          ) => (
                            <TableRow key={index}>
                              {index == 0 && (
                                <TableCell rowSpan={numberOfRow} align="left">
                                  <b>{item.code}:</b>
                                </TableCell>
                              )}
                              {item.submenu?.slice(index * 3, (index + 1) * 3).map((sub_item, sub_index) => {
                                // sub index la index cua ban ghi trong dong
                                const a = index * 3 + sub_index + 1;
                                const colSpan = a == numberOfKeys ? 3 + 1 - sub_index : 1;
                                return (
                                  <TableCell colSpan={colSpan} key={sub_index} align="left">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Checkbox disabled={!editable} checked={Boolean(sub_item.value)} onClick={() => handleChangeMenu(idx, 3 * index + sub_index)} />
                                      {sub_item.code}
                                    </div>
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          )
                        )}
                      </React.Fragment>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
      <DialogActions>
        <ButtonWithAPICallComponent disabled={!editable} variant="contained" api={handleClick} response={(res) => res.code === 200 && (inputData.id ? onSaveResponse(res) : onCreateResponse(res))}>
          {t(inputData?.id ? "Lưu" : "Tạo mới")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserGroup;
